import React from 'react';
import { useDashboardBreakpoint } from '@repo/common';

const getSidebarWidth = (bp) => {
  if (bp === 'desktopL') return 476;
  if (bp === 'desktopS') return 440;
  return 0;
};

const getContentPadding = (bp) => {
  if (bp === 'desktopL') return 40;
  if (bp === 'desktopS') return 24;
  if (bp === 'tabletV') return 40;
  if (bp === 'tabletH') return 16;
  return 0;
};

const getGutter = (bp) => {
  if (bp === 'desktopL') return 40;
  if (bp === 'desktopS') return 20;
  if (bp === 'tabletV' || bp === 'tabletH') return 30;
  return 0;
};

const getContentMaxWidth = (bp) => {
  if (bp === 'desktopS') return 1280;
  return '100%';
};

const getNavigationWidth = (padding) => padding + 76;

const DashboardLayout = ({ sidebar, leftPanel, children, fitViewport = true }) => {
  const bp = useDashboardBreakpoint();
  // fitViewport=true: 콘텐츠를 화면(100vh)에 고정(대시보드 여정맵처럼 내부 스크롤).
  // fitViewport=false: 콘텐츠 높이에 맞춰 늘어나며 페이지가 스크롤됨(긴 목록 페이지).
  const mainHeightClass = fitViewport ? 'h-screen' : 'min-h-screen';
  const padding =
    !leftPanel && bp === 'desktopS' ? 40 : getContentPadding(bp);
  const gutter = getGutter(bp);
  const sidebarWidth = leftPanel
    ? getSidebarWidth(bp)
    : getNavigationWidth(padding);
  const contentMaxWidth = getContentMaxWidth(bp);
  const isDesktop = ['desktopS', 'desktopL'].includes(bp);
  const isTablet = bp === 'tabletV';
  const isMobile = ['mobileMini', 'mobile', 'tabletH'].includes(bp);

  return (
    <div className='flex min-h-screen bg-bg-twodays'>
      {isDesktop && (
        <>
          <aside
            className='flex flex-row flex-shrink-0'
            style={{ width: sidebarWidth, gap: gutter }}
          >
            <div
              className='sticky top-0 flex h-screen flex-col flex-shrink-0'
              style={{
                paddingLeft: padding,
                paddingTop: padding,
                paddingBottom: padding,
              }}
            >
              {sidebar}
            </div>

            {leftPanel && (
              <div
                className='flex-1 w-full min-h-0'
                style={{
                  paddingTop: padding,
                  paddingBottom: padding,
                }}
              >
                {leftPanel}
              </div>
            )}
          </aside>

          <main
            className={`flex-1 min-w-0 ${mainHeightClass}`}
            style={{ paddingTop: padding, paddingRight: padding, paddingBottom: padding, paddingLeft: leftPanel ? 24 : padding, maxWidth: contentMaxWidth }}
          >
            {children}
          </main>
        </>
      )}

      {isTablet && (
        <div className='flex flex-row w-full'>
          <aside
            className='sticky top-0 flex h-screen flex-col flex-shrink-0'
            style={{
              paddingLeft: padding,
              paddingTop: padding,
              paddingBottom: padding,
            }}
          >
            {sidebar}
          </aside>

          <div className={`flex flex-col flex-1 min-w-0 ${mainHeightClass}`} style={{ padding }}>
            {leftPanel && <div className='w-full flex-shrink-0'>{leftPanel}</div>}
            <main className='w-full flex-1 min-h-0' style={{ marginTop: gutter }}>
              {children}
            </main>
          </div>
        </div>
      )}

      {isMobile && (
        <div className='flex flex-col w-full pt-[54px] px-4'>
          <header
            className='relative z-20 flex-shrink-0 w-full bg-bg-twodays'
            style={{
              paddingLeft: padding,
              paddingRight: padding,
            }}
          >
            {sidebar}
          </header>

          <div className='flex flex-col flex-1 min-w-0' style={{ padding }}>
            {leftPanel && (
              <div className='w-full' style={{ marginBottom: gutter }}>
                {leftPanel}
              </div>
            )}
            <main className='w-full'>{children}</main>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardLayout;
